import React, { useState } from "react";
import { Box, Button, Modal } from "fds";
import "./index.scss";
import useDocumentStore from "../../../../redux/dispatcher/useDocumentStore";
import { t } from "i18next";
interface DeleteFolderModalProps {
  open: boolean;
  targetFolderId?: string; // 삭제하고자 하는 폴더 ID
  folderName?: string; // 폴더명 ->표시목적
  onClose: () => void;
}

const DeleteFolderModal: React.FC<DeleteFolderModalProps> = ({
  open,
  onClose,
  folderName,
  targetFolderId,
}) => {
  /** Hook 정리 */
  const { deleteFolder } = useDocumentStore();

  /** State 정리 */
  const [checkFolderResponse, changeCheckFolderResponse] = useState(false);

  /** 함수 정리 */
  /** 폴더 삭제. 만약 삭제가 안된다면 폴더 내부에 권한없는 파일이 존재한다고 판단한다. */
  const handleDeleteFolder = async () => {
    let resp = await deleteFolder({ folderId: targetFolderId });
    if (resp.payload) {
      onClose();
    } else {
      changeCheckFolderResponse(true);
    }
  };
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={t("file.action.deleteFolder")}
      width={540}
      subTitle={folderName}
      subTitleEllipsis
      footer={
        checkFolderResponse ? (
          <Button
            btnStyle="fill"
            label={t("common.confirm")}
            onClick={onClose}
          />
        ) : (
          <Box>
            <Button
              btnStyle="fill"
              type="secondary"
              label={t("common.cancel")}
              onClick={onClose}
            />
            <Button
              btnStyle="fill"
              label={t("common.delete")}
              type="error"
              onClick={handleDeleteFolder}
            />
          </Box>
        )
      }
      bodyMsg={
        checkFolderResponse
          ? t("file.alert.noOwnerFolder")
          : t("file.alert.confirmDeleteFolder")
      }
    />
  );
};
export default DeleteFolderModal;
